import {
  GET_NET_SHIP_STYLE_WISE_REQUEST,
  GET_NET_SHIP_STYLE_WISE_SUCCESS,
  GET_NET_SHIP_STYLE_WISE_ERROR,
} from "./types.js";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const getNetShipStyleWise = (token, data, report) => (dispatch) => {
  dispatch({ type: GET_NET_SHIP_STYLE_WISE_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/netShippedCustomerWise`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: {
      from_date: moment(data.from_date).format("MM-DD-YYYY"),
      to_date: moment(data.to_date).format("MM-DD-YYYY"),
      factor_id: data.paymentClass === "All" ? null : data.paymentClass,
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_NET_SHIP_STYLE_WISE_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_NET_SHIP_STYLE_WISE_ERROR,
        payload: [],
      });
    });
};

